module.exports = {
  menu: {
    home: 'الصفحة الرئيسية',
    game: 'لعبة',
    connect_login: 'اتصال المحفظة / تسجيل الدخول',
    new_game: 'دخول اللعبة',
    invite_friends: 'دعوة الأصدقاء',
    cms_login: 'تسجيل دخول CMS',
    register: 'تسجيل',
    login: 'تسجيل الدخول',
    logout: 'تسجيل الخروج',
    login_to_play_game: 'سجل الدخول للعب اللعبة',
    select_login_method: 'يرجى اختيار طريقة تسجيل الدخول',
    select_register_method: 'يرجى اختيار طريقة التسجيل',
    email: 'البريد الإلكتروني',
    meta_mask: 'MetaMask',
    player_login: 'تسجيل دخول اللاعب',
    history: 'السجل',
    transaction_history: 'سجل المعاملات',
    ranking: 'التصنيف',
    purchase: 'إعادة الشحن',
    search_game_placeholder: 'بحث عن لعبة..',
    new_games: 'ألعاب جديدة',
    frequent: 'الألعاب المتكررة',
    faq: 'الأسئلة الشائعة',
    terms_and_conditions: 'شروط وأحكام Win4Poker',
    tnc: 'الشروط والأحكام',
    about_us: 'معلومات عنا',
    contact_us: 'اتصل بنا',
    settings: 'الإعدادات',
    lucky_draw: 'سحب الحظ',
    tournament: 'البطولة',
    announcement: 'إعلان',
    no_news: 'لا توجد أخبار',
    online: 'متصل',
    deposit: 'إيداع',
    terms_1_title: 'أهلية المشاركة',
    terms_1_content:
      'يجب أن يكون جميع اللاعبين عمرهم 18 عامًا على الأقل وأن يقوموا بالتسجيل واللعب في المناطق المسموح بها قانونًا.',
    terms_2_title: 'تسجيل الحساب',
    terms_2_content: 'يجب على اللاعبين تسجيل حساب من خلال الموقع الرسمي.',
    terms_3_title: 'قواعد اللعبة',
    terms_3_content:
      'يجب أن تتبع جميع الألعاب قواعد البوكر القياسية، وأي سلوك غش سيؤدي إلى تعليق أو إغلاق الحساب.',
    terms_4_title: 'الإيداع والسحب',
    terms_4_content:
      'يجب على اللاعبين استخدام طرق الدفع الخاصة بالمنصة للإيداع، وسيتم معالجة السحب وفقًا لوقت معالجة المنصة.',
    terms_5_title: 'توزيع الجوائز',
    terms_5_content:
      'سيتم توزيع الجوائز بناءً على نتائج اللعبة، وسيتم توضيح القواعد المحددة قبل بدء اللعبة.',
    terms_6_title: 'تحديد المسؤولية',
    terms_6_content: 'المنصة غير مسؤولة عن أي خسائر أو أضرار تنشأ أثناء استخدام أي خدمة أو منتج.',
    terms_7_title: 'حماية الخصوصية',
    terms_7_content:
      'سيتم الحفاظ على سرية المعلومات الشخصية للاعبين، وتستخدم فقط لإدارة الحساب والغرض من اللعبة.',
    terms_8_title: 'تعديل الشروط',
    terms_8_content:
      'تحتفظ المنصة بالحق في تعديل الشروط والأحكام في أي وقت، وسيتم إشعار اللاعبين بالتعديلات عبر البريد الإلكتروني أو إعلان على الموقع.',
  },
  common: {
    theme: 'خلفية المشروع الأساسي',
    delete_record_confirm_msg: 'هل أنت متأكد أنك تريد الحذف؟',
    yes: 'نعم',
    no: 'لا',
    true: 'نعم',
    false: 'لا',
    success: 'نجاح',
    loading: 'جارٍ التحميل',
    or: 'أو',
    delete: 'حذف',
    login: 'تسجيل الدخول',
    submit: 'إرسال',
    apply: 'تطبيق',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    back_to_lobby: 'العودة إلى اللوبي',
    email: 'البريد الإلكتروني',
    id_document: 'وثيقة إثبات الهوية',
    all_in_game: 'بوكر تكساس كل إن',
    all_in_game_omaha: 'أوماها كل إن',
    regular: 'بوكر تكساس',
    regular_description: 'بوكر تكساس بلون لا نهائي',
    short: 'الورق القصير',
    short_description: 'بوكر تكساس الورق القصير يستخدم 36 ورقة',
    omaha: 'أوماها',
    omaha_description: 'يجب على اللاعبين استخدام ورقتين من الورق الخاص لتشكيل اليد',
    regular_allin: 'بوكر تكساس كل إن',
    omaha_allin: 'أوماها كل إن',
    tournament: 'بطولة',
    start: 'بدء الطاولة',
    game_demo_area: 'منطقة تجربة اللعبة',
    total_win_prize: 'إجمالي الجائزة الفائزة',
    waiting_list_order: 'ترتيب قائمة الانتظار',
    join_more_than_4_room_error: 'لا يمكن الانضمام إلى أكثر من 4 غرف',
    system_message: 'رسالة النظام',
    error: 'خطأ',
    register: 'تسجيل',
    meta_mask: 'MetaMask',
    wallet_connect: 'Wallet Connect',
    password: 'كلمة المرور',
    next_step: 'الخطوة التالية',
    next: 'التالي',
    verify: 'تحقق',
    copy_success: 'تم النسخ بنجاح',
    enabled: 'مفعل',
    enable: 'تفعيل',
    disable: 'تعطيل',
    done: 'تم',
    feature_in_progress: 'الميزة قيد التطوير، يرجى المحاولة لاحقًا.',
    no_data: 'لا توجد بيانات',
    date: 'التاريخ',
    retry: 'إعادة المحاولة',
    location_restricted_title: 'قيود المنطقة',
    location_restricted_content:
      'المنطقة التي تتواجد فيها حاليًا تخضع للقيود. قد تكون بعض الميزات أو الخدمات غير متوفرة. نشكركم على تفهمكم.',
    dont_show_again: 'لا تظهر مرة أخرى',
    edit: 'تحرير',
    i_am_not_located_in_the_restricted_country: 'أنا لست موجوداً في البلد المقيد',
  },
  auth: {
    nickname: 'اللقب',
    connect_to_win_4_poker: 'الاتصال بـ WIN 4 POKER',
    wallet_connect_need_to_connect_ur_wallet: 'يتطلب التطبيق اتصال محفظتك',
    wallet_connect_sign_this_message:
      'يرجى العودة إلى المحفظة لتوقيع هذه الرسالة لإثبات ملكيتك للمحفظة والمتابعة. الإلغاء سيؤدي إلى قطع الاتصال.',
    sign_request_in_wallet: 'توقيع الطلب في المحفظة',
    sign_message_success: 'تم التوقيع بنجاح',
    cancel: 'إلغاء',
    sign: 'توقيع',
    confirm_password: 'تأكيد كلمة المرور',
    referral_code: 'رمز الإحالة',
    i_have_read_the_agreement: 'لقد قرأت الاتفاقية',
    should_accept_agreement: 'يرجى قبول الاتفاقية',
    alphabet_validation: 'يجب أن يحتوي على حرف واحد على الأقل',
    numeric_validation: 'يجب أن يحتوي على رقم واحد على الأقل',
    length_validation: 'يجب أن يحتوي على 8 أحرف على الأقل ولكن لا يتجاوز 20 حرفًا',
    placeholder: {
      enter_user_name: 'أدخل اسم المستخدم',
      enter_email: 'أدخل البريد الإلكتروني',
      enter_password: 'أدخل كلمة المرور',
      confirm_password: 'تأكيد كلمة المرور',
      enter_referral_code: 'أدخل رمز الإحالة',
    },
    error_messages: {
      nickname: 'يرجى إدخال لقبك',
      email_invalid: 'هذا بريد إلكتروني غير صالح',
      email_required: 'يرجى إدخال بريدك الإلكتروني',
      password_required: 'يرجى إدخال كلمة المرور',
      password_confirm_required: 'يرجى تأكيد كلمة المرور',
      password_confirm_not_matched: 'كلمتا المرور المدخلتان غير متطابقتان!',
      incorrect_email_or_password: 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
      error_occurred: 'حدث خطأ، يرجى المحاولة مرة أخرى لاحقًا',
    },

    // login-email page
    forget_password: 'نسيت كلمة المرور؟',

    // forgot-password page
    forgot_password_title: 'نسيت كلمة المرور',
    please_enter_email_registered: 'يرجى إدخال بريدك الإلكتروني المسجل',

    // email-verification page
    email_verification: 'التحقق من البريد الإلكتروني',
    email_has_been_sent_to: 'تم إرسال البريد الإلكتروني إلى {{value}}',
    email_resend_countdown_message:
      'لم تستلم البريد الإلكتروني؟ يمكنك طلب إعادة الإرسال بعد <0>العد التنازلي</0> ثانية',
    please_check_your_email: 'يرجى التحقق من بريدك الإلكتروني',
    waiting_to_verify_email: 'جارٍ التحقق من بريدك الإلكتروني',
    agree_terms_and_privacy:
      'بالاستمرار في هذه العملية، فإنك توافق على <0>الشروط</0> و<1>سياسة الخصوصية</1> الخاصة بنا.',
    terms: 'الشروط',
    privacy_policy: 'سياسة الخصوصية',

    // metamask-complete-registration page
    complete_metamask_registration: 'إكمال تسجيل MetaMask',

    // reset-password page
    reset_password: 'إعادة تعيين كلمة المرور',
    you_may_now_reset_password: 'يمكنك الآن إعادة تعيين كلمة المرور لحسابك.',

    register_an_account: 'لا تملك حسابًا؟ <0>سجل هنا</0>!',
    resend_code_message: 'لم تستلم البريد الإلكتروني؟ انقر هنا <0>لإعادة الإرسال</0>',

    // 2FA setup page
    two_fa_via_email_title: 'التحقق بخطوتين عبر البريد الإلكتروني',
    otp_has_been_sent_to_email: 'تم إرسال رمز التحقق لمرة واحدة إلى عنوان بريدك الإلكتروني المسجل.',
    two_factor_authentication: 'المصادقة الثنائية',
    scan_this_qr_code_msg:
      'لإعداد المصادقة الثنائية (2FA)، يرجى مسح رمز الاستجابة السريعة هذا باستخدام تطبيق مثل Authy أو Google Authenticator.',
    choose_scan_qr_code_msg:
      'افتح تطبيق المصادقة، انقر على رمز + في الأسفل. اختر مسح رمز الاستجابة السريعة.',
    choose_enter_setup_key_msg:
      'افتح تطبيق المصادقة، انقر على رمز + في الأسفل. اختر إدخال مفتاح الإعداد.',
    secret_key: 'المفتاح السري',
    enter_code_in_authenticator_app: 'يرجى إدخال الرمز المعروض في تطبيق المصادقة.',
    two_fa_is_set: {
      title: 'تم إعداد 2FA',
      message: 'لقد قمت بإعداد 2FA، وظيفة السحب متاحة الآن.',
    },

    // KYC page
    complete_email_verification_to_unlock_some_function:
      'أكمل التحقق من البريد الإلكتروني لفتح بعض الوظائف XXX',
    complete_id_verification_to_upgrade_withdrawal_amount:
      'أكمل التحقق من الهوية لزيادة مبلغ السحب إلى 100,000 USDT',
    connect_wallet_to_spin: 'ربط المحفظة',

    // enter code page
    link_email: 'ربط البريد الإلكتروني',
    unlink_email: 'إلغاء ربط البريد الإلكتروني',
    expires_in: 'ينتهي في <0>دقيقة</0>.',
    resend_code: '<0>إعادة إرسال الرمز</0>',
    enter_code: 'أدخل الرمز',
    unlink_email_confirm_msg: 'هل أنت متأكد أنك تريد إلغاء ربط البريد الإلكتروني؟',
    link_success: 'تم ربط البريد الإلكتروني بنجاح',
    unlink_success: 'تم إلغاء ربط البريد الإلكتروني بنجاح',
  },
  slider: {
    about: 'حول',
    support: 'الدعم',
  },
  game_room: {
    confirm_leave_msg: 'هل أنت متأكد أنك تريد مغادرة اللعبة؟',
    join_room_error_title: 'خطأ في الانضمام إلى الغرفة',
    join_room_error_msg: 'فشل الانضمام إلى الغرفة، يرجى المحاولة مرة أخرى',
    confirm_withdraw_extra_bet_msg: 'هل أنت متأكد أنك تريد سحب الرهان الإضافي؟',
    total_won_prize: 'إجمالي الجائزة الفائزة: ${{val, number}}',
    your_balance: 'رصيدك: ${{val, number}}',
    no_enough_balance: 'الرصيد أقل من الحد الأدنى لشراء الرهانات: ${{val, number}}',
    cash_out: 'سحب العملات الذهبية والمغادرة',
    continue_game: 'مواصلة اللعبة',
    remark_placeholder: 'ملاحظات',
    leave_seat: 'مغادرة المقعد',
    sit_in: 'العودة إلى المقعد',
    buy_in: 'شراء',
    buy_in_min_amount: 'الحد الأدنى',
    buy_in_max_amount: 'الأقصى',
    seconds: 'ثواني',
    close_drawer: 'إغلاق',
    leave_game: 'مغادرة اللعبة',
    back_to_lobby: 'العودة إلى الردهة',
    leave_table: 'مغادرة الطاولة',
    you_have_copied_room_code: 'لقد نسخت رمز دعوة الغرفة: {{value}}',
    invitation_message:
      'ادخل الآن إلى غرفة اللعبة التي أنشأها {{playerName}}! رمز دعوة الغرفة {{roomNumber}}، لنبدأ اللعب!',
    link_copied: 'تم نسخ الرابط بنجاح',
    please_wait_until_connected: 'يرجى الانتظار حتى الاتصال',
    rejoin_room: 'العودة إلى الغرفة',
    theme_setting: 'إعدادات الموضوع',
    room_code_share: 'نسخ رمز دعوة الغرفة',
    room_link_copy: 'مشاركة الرابط',
    table_setting: 'إعدادات الطاولة',
    emoji_menu: 'قائمة الرموز التعبيرية',
    history_drawer: 'تاريخ الغرفة',
    deposit: 'إيداع',
    withdraw_extra_bet: 'سحب الرهان الإضافي',
    add_extra_bet: 'إضافة رهان إضافي',
    unit_convert: 'تحويل الوحدة',
    silent_mode_on: 'وضع الصامت: مفعل',
    silent_mode_off: 'وضع الصامت: معطل',
    raise_to: 'زيادة إلى',
    winner: 'الفائز',
    player_status: {
      disconnected: 'غير متصل',
      sat_out: 'مغادر المقعد',
    },
    win_percentage: 'نسبة الفوز',
    all_in: 'كل إن',
    ping_popup_msg: 'إشارة الشبكة غير مستقرة، جارٍ محاولة إعادة الاتصال',
    ping_popup_title: 'إشارة الشبكة غير مستقرة',
    ping_popup_content: 'جارٍ محاولة إعادة الاتصال، يمكنك محاولة تحديث الصفحة',
    disconnected_modal_title: 'إشارة الشبكة غير مستقرة',
    afk_timer_text:
      'نظرًا لعدم استجابتك لفترة طويلة، تم إخراجك من المقعد. إذا لم تعد إلى الطاولة في الوقت المحدد، سيتم إخراجك من الغرفة',
    regular: 'بوكر تكساس',
    short: 'الورق القصير',
    omaha: 'أوماها',
    omaha_all_in: 'أوماها كل إن',
    buyin_option: 'خيارات الشراء',
    buy_in_amount: 'مبلغ الشراء',
    reminder: 'تذكير',
    not_enough_balance_to_buy_in: 'لا يوجد رصيد كافٍ للشراء.',
    sitting_out: 'مغادر المقعد',
    not_leaving_temporarily: 'عدم المغادرة مؤقتًا',
    back_to_home: 'العودة إلى الصفحة الرئيسية',
    are_you_sure_leave_table: 'أنت اللاعب الذي يملك أعلى رهان، هل أنت متأكد أنك تريد الخروج؟',
    leave_table_with_highest_bet_error:
      'أنت اللاعب الذي يملك أعلى رهان، لا يمكنك مغادرة الطاولة. يرجى المحاولة مرة أخرى لاحقًا.',
    loading_room_data: 'جارٍ تحميل بيانات الغرفة...',
    sit_out_tournament_warning: {
      title: 'تحذير الخروج من البطولة',
      msg: 'أنت حاليًا في بطولة. إذا خرجت من مقعدك، ستظل بحاجة إلى دفع الرهانات الإجبارية.',
    },
  },
  player_action: {
    bet: 'رهان',
    call: 'اتصال',
    check: 'تفقد',
    raise: 'رفع',
    fold: 'رمي',
    bb: 'الرهان الكبير',
    sb: 'الرهان الصغير',
    ante: 'المقدم',
    all_in: 'كل إن',
    insurance_cancel: 'إلغاء التأمين',
    insurance_buy: 'تأكيد التأمين',
  },
  game_demo: {
    experience_progress: 'تقدم رمز التجربة',
    game_experience_zone: 'منطقة تجربة اللعبة',
    action_to_redemption: 'إكمال 30 لعبة فعالة لاستبدال رمز نقدي',
    remaining_game_experience_code: 'متبقي {{val, number}}',
    cash_code_exchange: 'استبدال الرمز النقدي',
    successfully_finish_30_games: 'تم الإكمال بنجاح',
    congrats: 'تهانينا!',
    successful_exchange_cash_code: 'تم استبدال رمز نقدي بقيمة {{amount}} بنجاح',
    how_to_redeem: 'كيفية استبدال رمز التجربة برمز نقدي',
    successful_condition_of_redemption: 'الشرط: إكمال 30 لعبة فعالة',
    two_to_three_players: 'لعبة من 2-3 لاعبين',
    explanation_of_valid_game: 'تحقق من 10BB ونهاية اللعبة مع كشف الأوراق ليتم احتسابها كعبة فعالة',
    more_than_four_players: 'لعبة من 4 لاعبين أو أكثر',
  },
  userProfile: {
    profile_settings: 'إعدادات الملف الشخصي',
    initial_setting_title: 'مرحبًا بك في Win4.Poker',
    initial_setting_description: 'يرجى إكمال الإعدادات الأولية أدناه واستمتع بألعابنا',
    display_name: 'اسم العرض',
    profile_picture: 'صورة الملف الشخصي',
    edit: 'تحرير',
    balance: 'الرصيد',
    coin: 'USD',
    demo_coin: 'رمز تجربة نقدي',
    diamond: 'ألماس',
    game_record: 'سجل اللعبة',
    ranking_list: 'قائمة التصنيف',
    game_review: 'مراجعة اللعبة',
    shortcut_setting: 'إعدادات الاختصار',
    user_name: 'اسم المستخدم:',
    recommend_code: 'رمز الإحالة',
    upload_image_msg: 'اسحب الصورة إلى هنا، أو',
    upload_image_browser_msg: 'تصفح',
    upload_image_file_size: '(حجم الملف الأقصى: 68px*93px)',
    username_length_message: 'يجب أن يكون طول اسم المستخدم بين 3-24',
    chinese_username_length_message:
      'يجب أن يكون طول اسم المستخدم الذي يحتوي على أحرف صينية بين 1-5',
    username_char_message:
      "يمكن أن يحتوي اسم المستخدم فقط على أحرف، أرقام، أحرف صينية و'_'/'-'/'.'",
    personal_information: 'المعلومات الشخصية',
    user_icon: 'رمز المستخدم:',
    save: 'حفظ',
    my_profile: 'ملفي الشخصي',
    my_balance: 'رصيدي',
    deposit_withdraw: 'إيداع/سحب',
    my_record: 'سجلي',
    flow_record: 'سجل التدفق',
    total_earnings: 'إجمالي الأرباح',
    country: 'البلد',
    disclaimer: 'الاستثناءات',
  },
  maintenance: {
    title: 'الموقع تحت الصيانة',
    content: 'نحن نعمل على تحسين تجربة المستخدم. سنعود قريبًا. شكرًا على صبرك.',
  },
  useSetting: {
    card_front: 'واجهة البطاقة',
    card_back: 'ظهر البطاقة',
    table: 'طاولة',
    add_token_msg: 'هل تحتاج إلى إضافة المزيد من الرموز؟',
  },
  lucky_draw: {
    award_history: 'سجل الجوائز',
    lucky_draw_rules: 'القواعد',
    remaining_lucky_draw_amount: 'الفرص المتبقية: {{value}}',
    remaining_lucky_draw_amount_loading_label: 'الفرص المتبقية: ',
    spin_wheel_10_times: 'دوِّر العجلة عشر مرات',
    spin_wheel: 'دوِّر العجلة',
    participation_rate: 'معدل المشاركة في اللعبة: {{count}}',
    coin_loss: 'معدل خسارة العملات',
    congrats: 'تهانينا!',
    you_have_won: 'لقد ربحت ${{prize}}',
    collect_prize: 'استلم جائزتك',
    select_category: 'اختر فئة السحب: ',
    special_combination: 'تركيبة خاصة: ',
    no_history: 'لا يوجد سجل سحب',
    no_data: 'لا توجد بيانات متوفرة',
    spin: 'دوِّر',
    fortune_wheel: 'عجلة الحظ',
    christmas_fortune_wheel: 'عجلة حظ عيد الميلاد',
    new_year_fortune_wheel: 'عجلة حظ رأس السنة',
    cny_fortune_wheel: 'عجلة الحظ للعام الصيني الجديد',
    email_login: 'تسجيل الدخول',
    thank_you: 'شكراً لك',
    miss_msg_1:
      'شكراً لمشاركتك في فعاليتنا، ليس لديك فرص متبقية، يمكنك الانضمام إلى لعبتنا للفوز بمزيد من المال. استمتع وبالتوفيق.',
    play_now: 'العب الآن',
    win_msg: 'لقد فزت <br/> <large>{{prize}}</large> <br /> وتم حفظه في رصيدك.',
    draw_again_msg:
      'لديك <yellow>{{numOfDraws}}</yellow> سحبات متبقية. <clickable>انقر للسحب مرة أخرى.</clickable>',
    diamond: '{{value}} ألماسة',
    redeem_now: 'استرداد الآن',

    deposit_more_than_10: 'قم بإيداع أكثر من 10$',
    get_1_free_spin: 'احصل على دورة مجانية',
    win_10_times: 'اربح 10 مرات',
  },
  combination: {
    hi_card: 'أعلى ورقة',
    pair: 'زوج',
    one_pair: 'زوج واحد',
    two_pairs: 'زوجان',
    set: 'ثلاثة من نفس النوع',
    three_of_a_kind: 'ثلاثة من نفس النوع',
    straight: 'ستريت',
    flush: 'فلش',
    fullHouse: 'فول هاوس',
    full_house: 'فول هاوس',
    quad: 'كواد',
    straight_flush: 'ستريت فلش',
    royal_flush: 'رويال فلش',
  },
  room_type: {
    public: 'غرفة عامة',
    private: 'غرفة خاصة',
  },
  forgot_password: {
    reset_password: 'إعادة تعيين كلمة المرور',
    password: 'كلمة المرور',
    confirm_password: 'تأكيد كلمة المرور',
    phone: 'الهاتف',
  },
  error: {
    please_confirm: 'يرجى التأكيد',
    password_inconsistent: 'كلمات المرور غير متطابقة',
    file_size_limit_error: 'حجم الملف المسموح به هو {{size}}',
    please_input: 'يرجى إدخال {{field}}',
  },
  translation: {
    success: 'نجاح',
  },
  game_list: {
    table: 'طاولة',
    random_join_table: 'انضمام عشوائي إلى الطاولة',
    random_join: 'انضمام عشوائي',
    join: 'انضمام',
    no_room_available: 'لا توجد غرف، يرجى العودة لاحقًا.',
    all_game_loaded: 'تم تحميل جميع الألعاب',
    join_waiting_list: 'انضمام إلى قائمة الانتظار',
    join_table: 'انضمام إلى الطاولة',
    join_observer: 'مراقبة',
    game_code: 'رمز الطاولة',
    game_type: 'نوع اللعبة',
    game_limit: 'الحد الأقصى للأشخاص',
    game_players: 'عدد اللاعبين',
    game_unit_test: 'اختبار الوحدة',
    game_basicBet: 'رهان أساسي',
    game_SB: 'SB',
    game_smallBlind: 'الرهان الصغير',
    regular: 'بوكر تكساس',
    all_in: 'بوكر تكساس كل إن',
    short: 'الورق القصير',
    omaha: 'أوماها',
    omaha_all_in: 'أوماها كل إن',
    buy_in: 'شراء',
    tables: 'طاولات',
    notice: 'تنبيه',
    time_difference_reminder:
      'هناك فرق غير عادي بين وقت نظامك ووقت الإنترنت، قد يؤثر ذلك على وظيفة العد التنازلي للاعبين. لضمان الأداء الأمثل والدقة، يرجى مزامنة وقت النظام في أقرب وقت ممكن.',
    player_category: 'تصنيف اللاعب',
    blind_category: 'تصنيف الرهان',
    table_category: 'تصنيف الطاولة',
    chips: 'رقائق',
    player: 'لاعب',
    waiting: 'انتظار',
    avg_pot: 'متوسط الوعاء',
    flop_rate: 'معدل الفلوب',
    hands_per_hour: 'الأيادي في الساعة',
    no_of_hands_played: 'إجمالي الأيادي',
    win: 'فوز',
    invested: 'استثمار',
    pot: 'الجائزة',
    usd_balance_updated: 'تم تحديث رصيد الدولار الأمريكي إلى ${{balance}}',
    new_room: 'غرفة جديدة',
    game: 'لعبة',
    tournament: 'بطولة',
  },
  game_review: {
    my_bets: 'رهاناتي',
    date_range: 'نطاق التاريخ',
    select_date_range: 'اختر نطاق التاريخ',
    show_all_dates: 'عرض جميع التواريخ',
    show_selected_dates: 'عرض التواريخ المحددة',
    no_game_record: 'لا توجد سجلات للعبة',
    win_row_message: 'فوز!!',
    lose_row_message: 'خسارة',
    ante: 'المقدم',
    win: 'فوز',
    lose: 'خسارة',
    main_pot: 'الوعاء الرئيسي',
    side_pot: 'وعاء جانبي {{number}}',
  },
  leader_board: {
    rank: 'الترتيب',
    name: 'الاسم',
    win_game: 'إجمالي الفوز',
    score: 'النقاط',
  },
  home: {
    dont_miss_promotion_msg: 'لا تفوتهم',
    all_promotions: 'جميع العروض الترويجية',
    my_game: 'لعبتي',
    all_games: 'جميع الألعاب',
    claim_first_time_reward_button: 'تعلم',
    first_time_login: 'تسجيل الدخول لأول مرة في اللعبة،',
    first_time_reward_msg: 'ستحصل على {{val}} عملات تجربة',
    open_table: 'فتح طاولة',
    open_new_room: 'إنشاء غرفة جديدة',
    enter_room_number: 'أدخل رمز الغرفة',
    start: 'بدء الطاولة',
    enter_code: 'أدخل رمز السحب',
    confirm: 'تأكيد',
    game_selection: 'اختيار اللعبة',
    start_game: 'بدء الطاولة / الانضمام إلى الغرفة',
    game_record: 'سجل اللعبة',
    join_private_room: 'انضمام إلى غرفة خاصة',
    roomCode: 'رمز الغرفة',
    please_enter_a_valid_room_code: 'يرجى إدخال رمز سحب صالح',
    notice: 'تنبيه',
    time_difference_reminder:
      'هناك فرق غير عادي بين وقت نظامك ووقت الإنترنت، قد يؤثر ذلك على وظيفة العد التنازلي للاعبين، يرجى مزامنة وقت النظام في أقرب وقت ممكن. إذا قمت بالمزامنة، يرجى تحديث الصفحة.',
    register_success: 'تم التسجيل بنجاح',
    referral_code: 'رمز الإحالة',
    referral_code_placeholder: 'أدخل رمز الإحالة',
    display_name: 'اسم العرض',
    display_name_placeholder: 'أدخل اسم العرض',
    user: 'لاعب',
    bet_amount: 'مبلغ الرهان',
    date: 'التاريخ',
    multiplier: 'المضاعف',
    payout: 'الجائزة',
    free_game: 'لعبة مجانية',
    play_without_money: 'اللعب بدون أموال',
    private_game: 'غرفة خاصة',
    play_with_friends: 'العب مع الأصدقاء',
    regular_content: 'بوكر تكساس التقليدي يستخدم الرهان اللانهائي',
    all_in_content: 'بوكر تكساس كل إن أو فولش يستخدم الرهان اللانهائي',
    short_content: 'بوكر تكساس الورق القصير يستخدم الرهان اللانهائي',
    omaha_content: 'أوماها حد الوعاء يستخدم الرهان اللانهائي',
    omaha_all_in_content: 'أوماها كل إن أو فولش يستخدم الرهان اللانهائي',
    player_statistics: 'إحصائيات اللاعبين',
    lucky_draw_reminder: {
      title: 'تذكير',
      message: 'لديك {{value}} دوران محظوظ متبقية',
      go_to_lucky_draw: 'اذهب إلى السحب المحظوظ',
      spin_now: 'سحب الآن',
    },
  },
  disclaimer: {
    title: 'إخلاء المسؤولية',
    message:
      'إذا كنت تعيش في أي من المناطق المقيدة التالية، فلا يُسمح لك بلعب الألعاب على win4.poker',
    countryList:
      'الولايات المتحدة الأمريكية، تركيا، أروبا، بونير، كوراساو، فرنسا، هولندا، السويد، إسرائيل، ليتوانيا، سلوفاكيا، بلجيكا، سويسرا، سابا، سانت أوغوستو، سانت مارتن، الصين، المملكة المتحدة.',
    checkbox_message:
      'أؤكد أن القمار غير محظور من قبل السلطات في مكاني وأنني أبلغ من العمر 18 عامًا على الأقل.',
    required_message: 'يرجى الموافقة على إخلاء المسؤولية',
  },
  login: {
    user_account: 'اسم المستخدم',
    password: 'كلمة المرور',
    cash_web_login: 'تسجيل دخول مستخدم النقدية',
    player_register: 'تسجيل لاعب',
    gateway_user_name: 'اسم مستخدم البوابة',
    cms_login: 'تسجيل دخول CMS',
    deposit: 'إيداع الأموال',
    deposit_amount: 'مبلغ الإيداع',
    deposit_message: 'يتطلب إدخال مبلغ الإيداع',
    notice: 'تنبيه',
    duplicate_login: 'تم اكتشاف تسجيل دخول من نفس IP',
    redirecting: 'ستتم إعادة توجيه صفحتك قريبًا، شكرًا على صبرك.',
    loading: 'جارٍ تحميل الموارد، يرجى الانتظار...',
  },
  verification: {
    email_verification_code: 'رمز التحقق من البريد الإلكتروني',
    email_not_verify_error: 'البريد الإلكتروني غير مُحقق',
    confirm: 'تأكيد',
    timer_count: 'العد التنازلي',
    resend_verification_code: 'إعادة إرسال رمز التحقق',
    send_verification_code: 'إرسال رمز التحقق',
    input_field: 'أدخل {{field}}',
    code: 'الرمز',
    successful_verify: 'تم التحقق بنجاح',
    two_factor_authentication: 'المصادقة الثنائية',
    verification: 'التحقق',

    // KYC page
    verify: 'التحقق من الهوية',
    security: 'الأمان',

    kyc_status: {
      failed_verify_again: 'فشل التحقق، حاول مرة أخرى',
      under_review: 'قيد المراجعة',
      verify_now: 'تحقق الآن',
    },

    complete_email_verification_to_unlock_some_function:
      'أكمل التحقق من البريد الإلكتروني لفتح بعض الوظائف XXX',
    complete_id_verification_to_upgrade_withdrawal_amount:
      'أكمل التحقق من الهوية لزيادة مبلغ السحب إلى 100,000 USDT',
    requirement: 'المتطلبات',
    verify_now: 'تحقق الآن',

    verification_code: 'رمز التحقق',
    email_verification: {
      title: 'التحقق من البريد الإلكتروني',
      msg: 'يرجى إدخال عنوان بريد إلكتروني يمكنه استقبال رموز التحقق.',
      otp_has_been_sent_to: 'تم إرسال رمز التحقق إلى {{value}}',
    },

    id_card: 'بطاقة الهوية',
    passport: 'جواز السفر',

    identity_verification: {
      title: 'التحقق من الهوية',
      msg: 'يرجى استخدام وثيقة إثبات هوية صالحة للقيام بالتحقق من الهوية.',
      issuing_country: {title: 'اختر دولة إصدار الوثيقة', placeholder: 'اختر دولة'},
      document_type: {
        title: 'اختر نوع وثيقة إثبات الهوية',
        placeholder: 'اختر نوع وثيقة إثبات الهوية',
      },
    },

    uploadDocument: {
      title: 'تحميل الوثيقة',
      make_sure_that_your: 'تأكد من أن وثيقتك:',
      is_clear_and_easy_to_read: 'واضحة وسهلة القراءة',
      is_unedited: 'غير معدلة',
      the_whole_doc_must_appear_in_photo: 'يجب أن تظهر الوثيقة كاملة في الصورة',
      no_reflective_glare: 'بدون توهج انعكاسي',

      upload_image: 'تحميل صورة',
      upload_image_requirement: 'يجب أن يكون حجم الملف أقل من 10MB، ويدعم صيغة jpeg أو png.',
      front_side_of_id: 'الجانب الأمامي لبطاقة الهوية',
      back_side_of_id: 'الجانب الخلفي لبطاقة الهوية',
      personal_data_page_of_passport: 'صفحة البيانات الشخصية لجواز السفر',
      document_uploaded: 'تم تحميل الوثيقة',
      id_document_under_review_msg:
        'وثيقة إثبات هويتك قيد المراجعة، قد يستغرق التحقق من الهوية يومًا إلى يومين عمل.',
    },

    disable_2fa: {
      title: 'تعطيل المصادقة الثنائية',
      description: 'للمتابعة، يرجى إدخال رمز التحقق المقدم من تطبيق المصادقة للتحقق من هويتك',
      success_message: 'تم تعطيل المصادقة الثنائية',
    },

    error_messages: {
      document_upload_required: 'يرجى تحميل الوثيقة',
      selection_required: 'يرجى اختيار خيار واحد',
    },
  },
  table_area: {
    pot: 'الوعاء',
    waiting_for_other_players: 'انتظار لاعبين آخرين للجلوس...',
    waiting_for_game_start: 'انتظار بدء اللعبة',
    sixty_sec: '60 ثانية',
    please_select_emoji_target: 'يرجى اختيار اللاعب',
  },
  best_combination: {
    hi_card: 'أعلى ورقة ({{value}})',
    one_pair: 'زوج واحد ({{value}})',
    two_pairs: 'زوجان ({{firstPair}}, {{secondPair}})',
    set: 'ثلاثة من نفس النوع ({{value}})',
    straight: 'ستريت (من {{fromValue}} إلى {{toValue}})',
    flush: 'فلش (أعلى ورقة {{value}})',
    fullHouse: 'فول هاوس ({{three_cards}} و{{two_cards}})',
    quad: 'كواد ({{value}})',
    straight_flush: 'ستريت فلش (من {{fromValue}} إلى {{toValue}})',
    royal_flush: 'رويال فلش',
  },
  action_buttons: {
    place_bet: 'ضع رهان',
    all_in: 'كل إن',
    bet: 'رهان',
    check: 'تفقد',
    call: 'اتصال',
    raise: 'رفع',
    fold: 'رمي',
    pot: 'الوعاء',
    confirm: 'تأكيد',
    investment: 'استثمار',
    insurance: 'تأمين',
    choosing_cards: 'اختيار البطاقات',
    outs_number: 'عدد الأوتس',
    insurance_winning_rate: 'معدل الفوز',
    odds: 'الاحتمالات',
    premium: 'قسط التأمين',
    payout: 'الجائزة',
    call_any: 'اتصال تلقائي',
    wait_for_blinds: 'انضم بعد الرهان',
    join_directly: 'انضم في الجولة التالية',
    check_or_fold: 'تفقد / رمي',
    confirm_to_fold: 'هل أنت متأكد أنك تريد رمي البطاقات؟',
    max: 'الأقصى',
    min: 'الحد الأدنى',
    force_insurance: 'تأمين إجباري',
  },
  history_drawer: {
    title: 'تاريخ الغرفة',
    small_blind: 'الرهان الصغير (المقدم)',
    pre_flop: 'ما قبل الفلوب',
    flop: 'الفلوب',
    turn: 'الترن',
    river: 'الريفر',
    no_data: 'لا توجد بيانات للغرفة',
    hands: 'الأيادي',
    winner: 'الفائز',
    buy_in: 'شراء',
    pool: 'الوعاء',
    win_player: 'اللاعب الفائز',
    time: 'الوقت',
    main_pot: 'الوعاء الرئيسي',
    side_pot_one: 'وعاء جانبي 1',
    side_pot_two: 'وعاء جانبي 2',
    side_pot_three: 'وعاء جانبي 3',
    win: 'فوز',
    loading: 'جارٍ التحميل',
    all_record_loaded: 'تم تحميل جميع سجلات الغرف',
    previous_page: 'الصفحة السابقة',
    close: 'إغلاق',
    detail: 'تفاصيل',
  },
  file_upload: {
    upload: 'تحميل',
  },
  user_menu: {
    two_factor: 'المصادقة الثنائية',
    change_password: 'تغيير كلمة المرور',
    logout: 'تسجيل الخروج',
    hello_user: 'مرحبًا',
  },
  change_password_board: {
    change_password: 'تغيير كلمة المرور',
    old_password: 'كلمة المرور القديمة',
    new_password: 'كلمة المرور الجديدة',
    confirm_password: 'تأكيد كلمة المرور',
  },
  list_page: {
    export_title: '',
    export_info: '',
    search_bar_placeholder: 'بحث..',
    filter: 'تصفية',
    confirm_to_export: '',
    create_board: '',
    update_board: '',
  },
  permission_assigner: {
    read: 'قراءة',
    write: 'كتابة',
    none: 'لا شيء',
    banned: 'محظور',
  },
  phone_input: {
    invalid_country_code: 'رمز دولة غير صالح',
    invalid_phone: 'رقم هاتف غير صالح',
    phone_number: 'رقم الهاتف',
    phone_code: 'رمز المنطقة',
  },
  room_setting_drawer: {
    create_new_room: 'إنشاء غرفة جديدة',
    enter_room_code: 'أدخل رمز الغرفة',
    please_enter_a_valid_room_code: 'يرجى إدخال رمز سحب صالح',
    please_input_room_code: 'يرجى إدخال رمز الغرفة',
    enter_room: 'دخول الغرفة',
    room_setting: 'إعدادات الغرفة',
    small_blind: 'الرهان الصغير:',
    ante: 'المقدم:',
    buy_in: 'إيداع:',
    number_of_people: 'عدد الأشخاص:',
    action_time: 'وقت الإجراء:',
    game_duration: 'مدة اللعبة:',
    commission: 'العمولة:',
    insurance: 'التأمين:',
    location_restriction: 'قيود الموقع',
    diamond_needed: 'الألماس المطلوب:',
    diamond_owned: 'الألماس المملوك:',
    redeem: 'شراء الألماس',
    open_room: 'إنشاء الغرفة',
    maximum: 'الحد الأقصى:',
    hours: '{{value}} ساعات',
    minute: '{{value}} دقائق',
    second: '{{value}} ثوانٍ',
    affect_diamond_needed: 'تأثير الألماس المطلوب',
    remaining_room_time: 'الوقت المتبقي لانتهاء الغرفة',
    diamond_require: 'الألماس المطلوب:',
    time_increase: 'زيادة الوقت:',
    recharge: 'إعادة الشحن',
    isAllIn: 'كل إن',
    ipchecking: 'تحديد IP',
    diamond_not_enough: 'رصيد الألماس غير كافٍ',
  },
  gameRecharge: {
    sticker_title: 'ملصقات',
    check_for_more: 'تحقق للمزيد',
    diamond_title: 'ألماس',
    diamond_product_tag: '{{value}} ألماس',
    buy_diamond_confirm_msg: 'تأكيد الشراء',
    buy_sticker_confirm_msg: 'هل تريد شراء هذه الملصقة؟',
    balance_not_enough_msg: 'رصيدك غير كافٍ',
    sticker_product_tag: 'يتطلب {{value}} ألماس',
    confirm_to_buy_button: 'تأكيد',
    confirm_title: 'تأكيد الشراء',
    confirm_message:
      'هل تؤكد أنك تريد شراء {{diamondAmount}} ألماس مقابل USD$ <0>{{usdAmount}}</0>؟',
    redeem: 'إعادة الشحن',
    confirm: 'تأكيد',
    reminder: 'تذكير',
    not_enough_money: 'عذرًا، رصيدك غير كافٍ لشراء الألماس.',
    not_enough_diamond: 'رصيد الألماس لديك غير كافٍ، يرجى شراء الألماس أولاً.',
    quanity: 'الكمية:',
    price: 'السعر:',
    diamond: 'ألماس',
    sticker: 'ملصق',
    purchase_success: 'تم الشراء بنجاح',
    purchase: 'شراء',
    diamond_balance: 'رصيد الألماس',
    free_sticker: 'هذا منتج مجاني',
    amount_required: 'مطلوب إدخال الكمية',
    valid_amount: 'يرجى إدخال كمية صالحة',
    not_enough_diamond_balance: 'رصيد الألماس غير كافٍ',
  },
  transactionRecord: {
    transactionCurrencyType: {
      all: 'الكل',
      usd: 'USD',
      cash: 'رمز تجربة نقدي',
      diamond: 'ألماس',
    },
    transactionType: {
      createRoom: 'إنشاء غرفة خاصة',
      luckyDraw: 'لعب سحب الحظ',
      purchaseItem: 'شراء ملصقات',
      purchaseDiamond: 'شراء {{value}} ألماس',
      joinGame: 'المشاركة في {{value}} لعبة',
      winGame: 'فوز في {{value}} لعبة',
      loseGame: 'خسارة في {{value}} لعبة',
      winGameWithoutGameType: 'فوز في اللعبة',
      loseGameWithoutGameType: 'خسارة في اللعبة',
      joinGameWithoutGameType: 'المشاركة في اللعبة',
      deposit: 'إعادة الشحن',
      redeemDemo: 'استبدال رمز نقدي',
      insurance: 'تأمين',
      gift: 'هدية',
      firstLogin: 'تسجيل الدخول لأول مرة',
      privateRoomRebate: 'إعادة رصيد غرفة خاصة',
    },
    transactionRecord: 'تفاصيل التدفقات',
    no_transaction_record: 'لا توجد سجلات معاملات',
    currentMonth: 'هذا الشهر',
  },
  emojiPanel: {
    buy_sticker_confirm_msg: 'هل تريد شراء هذه الملصقة؟',
    sticker_product_tag: 'يتطلب {{value}} ألماس',
    confirm_to_buy_button: 'تأكيد الشراء',
    emoji: 'رموز تعبيرية',
    free: 'مجاني',
    no_available_emoji: 'لا توجد ملصقات متاحة',
  },
  playerInfo: {
    button: 'البنك',
    smallBlind: 'الرهان الصغير',
    bigBlind: 'الرهان الكبير',
    cutOff: 'القطع',
    underTheGun: 'تحت البندقية',
    bet: 'رهان',
    check: 'تفقد',
    call: 'اتصال',
    raise: 'رفع',
    fold: 'رمي',
    cancelInsurance: 'إلغاء التأمين',
    confirmInsurance: 'تأكيد التأمين',
    allIn: 'كل إن',
    skip: 'تخطي',
  },
  deposit_withdraw: {
    currency_usdt: 'تيثر (USDT)',
    deposit_method: 'طريقة الإيداع',
    remark: 'ملاحظة',
    ton_connect: 'اتصال TON',
    manual_deposit: 'إيداع يدوي',
    usdt: 'USDT',
    eth: 'ETH',
    btc: 'BTC',
    deposit: 'إيداع',
    withdraw: 'سحب',
    withdrawal: 'سحب',
    history: 'سجل الإيداع والسحب',
    blockchain: 'البلوكشين',
    currency: 'العملة',
    network: 'الشبكة',
    exchange_rate: 'سعر الصرف',
    deposit_address: 'عنوان الإيداع',
    deposit_process_message_1:
      'بعد استلام النظام للأموال، سيتم معالجة الإيداع على الفور، العملية قد تستغرق ساعتين تقريبًا، يرجى الانتظار بصبر.',
    back: 'عودة',
    address: 'العنوان',
    transaction_id: 'رقم المعاملة',
    amount: 'مبلغ السحب',
    time: 'الوقت',
    coin_type: 'نوع العملة',
    available_amount: 'المبلغ المتاح للسحب',
    withdraw_amount: 'مبلغ السحب',
    withdraw_cost: 'تكلفة السحب',
    receiving_amount: 'المبلغ المتوقع استلامه',
    deposit_amount: 'مبلغ الإيداع',
    deposit_amount_placeholder: 'يرجى إدخال مبلغ الإيداع',
    no_data: 'لا توجد بيانات',
    address_placeholder: 'يرجى إدخال العنوان',
    amount_placeholder: 'يرجى إدخال المبلغ',
    withdrawal_amount: 'مبلغ السحب',
    withdrawal_fee: 'رسوم السحب',
    max: 'الأقصى',
    available_cash_out_balance: 'الرصيد المتاح للسحب',
    cash_out_info:
      'بعد المشاركة في الجوائز، يمكنك فقط سحب USDT الذي فزت به في ألعاب البوكر، أو في حالة التعادل يمكنك السحب.',
    wallet_balance: 'رصيد المحفظة',
    deposit_pending_title: 'إيداع قيد الانتظار',
    deposit_pending_description: 'إيداعك قيد الانتظار حاليًا للموافقة',
    deposit_success_title: 'إيداع ناجح',
    deposit_success_description: 'تم إيداع الأموال في حسابك',
    create_withdraw_success_title: 'طلب السحب ناجح',
    create_withdraw_success_description: 'طلب السحب الخاص بك قيد المعالجة',
    withdrawal_success_title: 'تمت عملية السحب بنجاح',
    withdrawal_success_description: 'تم استكمال طلب السحب الخاص بك',
    amount_required: 'المبلغ مطلوب',
    amount_exceeds_available: 'المبلغ يتجاوز الرصيد المتاح',
    amount_below_minimum: 'المبلغ أقل من الحد الأدنى',
    amount_below_fee: 'المبلغ أقل من الرسوم',
    invalid_number: 'رقم غير صالح',
    network_required: 'مطلوب اختيار الشبكة',
    address_required: 'مطلوب إدخال العنوان',
    blockchain_required: 'مطلوب اختيار البلوكشين',
    email_required: 'مطلوب إدخال البريد الإلكتروني',
    valid_amount: 'يرجى إدخال مبلغ صالح',
    notice: 'تنبيه',
    cancel: 'إلغاء',
    cancel_transaction: 'لقد ألغيت المعاملة',

    from: 'من',
    receive_amount: 'المبلغ المستلم',

    // 2FA
    two_fa_required_msg: 'من أجل الأمان، يجب إعداد المصادقة الثنائية قبل السحب.',
    setup_2fa: 'إعداد المصادقة الثنائية',
    lost_my_2fa_access: 'فقدت الوصول إلى المصادقة الثنائية',

    wallets_usdt_token: 'رمز USDT في المحفظة',
    memo_reminder_1:
      'يرجى التأكد من إدخال {{memo}} في قسم الملاحظات، وإلا فلن يتمكن نظامنا من إيداع الأموال في حسابك.',
    memo_reminder_2: 'إذا كنت تستخدم TonConnect، فسيقوم النظام بملئه تلقائيًا.',

    wait_for_next_lucky_draw:
      'يرجى انتظار الحدث القادم للسحب المحظوظ للحصول على فرصة للحصول على أموال للعب.',
  },
  history_status: {
    completed: 'مكتمل',
    pending: 'قيد المعالجة',
  },
  transaction_history: {
    tab_titles: {
      all_flow: 'جميع التدفقات',
      deposits: 'الإيداعات',
      withdrawals: 'السحوبات',
      bets: 'الرهانات',
      purchase: 'شراء الألماس',
      diamond: 'ألماس',
    },
    transaction_type: 'نوع المعاملة',
    transaction_types: {
      deposits: 'إيداع',
      withdrawals: 'سحب',
      bets: 'رهان',
      purchase: 'شراء الألماس',
      diamond: 'ألماس',
      purchase_item: 'معاملة الألماس',
      referral_commission: 'عمولة الإحالة',
      payout: 'جائزة',
      private_room: 'إنشاء غرفة خاصة',
      private_room_rebate: 'إعادة رصيد الغرفة الخاصة',
      reward: 'مكافأة',
      lucky_draw: 'سحب الحظ',
      tournament_ticket_fee: 'رسوم التذكرة البطولة',
      tournament_prize: 'جائزة البطولة',
    },
    game_type: 'نوع اللعبة',
    type: 'النوع',
    bet: 'رهان',
    payout: 'جائزة',
    amount: 'المبلغ',
    quantity: 'الكمية',
    balance: 'الرصيد',
    diamond: 'ألماس',
    sticker: 'ملصق',
  },
  referral: {
    referral: 'إحالة',
    invite_friends_description: 'ادعُ أصدقاءك للانضمام إلى Win4Poker واحصل على مكافآت',
    whatsapp_referral_message:
      'هل أنت مستعد للفوز بالبطاقات؟ 🃏 انضم إلي في Win4Poker واستمتع بألعاب رائعة! هذا هو رابط دعوتي: ',
    number_of_referrals: 'عدد الإحالات',
    referral_rewards: 'مكافآت الإحالة',
    my_commission: 'عمولتي',
    referral_code: 'رمز الإحالة',
    referral_link: 'رابط الإحالة',
    enter_code: 'أدخل الرمز',
    terms_and_conditions: 'شروط وأحكام Win4Poker',
    invite_friends: 'دعوة الأصدقاء',
    pop_up_title: 'تنبيه',
    back_home: 'العودة إلى الصفحة الرئيسية',
    scan_qr_code: 'مسح رمز الاستجابة السريعة',
    code: 'رمز',
    copy_link: 'نسخ الرابط',
    save_image: 'حفظ الصورة',
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    more: 'المزيد',
    referral_history: 'سجل الإحالات',
    register_time: 'وقت التسجيل',
    player: 'لاعب',
    reward_time: 'وقت المكافأة',
    reward_amount: 'مبلغ المكافأة',
    referral_list: 'قائمة الإحالات',
    enter: 'أدخل',
    skip: 'تخطي',
    please_input_referral_code: 'يرجى إدخال رمز الإحالة',
    enter_referral_code: 'أدخل رمز الإحالة',
    enter_referral_code_success: 'تم إدخال رمز الإحالة بنجاح',
    cannot_use_own_referral_code: 'لا يمكنك استخدام رمز إحالتك الخاص',
    total: 'الإجمالي',
    referral_code_invalid: 'رمز الإحالة غير صالح',
    commission: 'عمولة',
    reward_type: 'نوع المكافأة',
    amount: 'المبلغ',
    commission_reward: 'مكافأة العمولة',
    commission_update_success: 'تم تحديث العمولة بنجاح',
    commission_setting: 'إعدادات العمولة',
    save: 'حفظ',

    // title
    promotion_1: 'الإحالة 1: مكافأة الإيداع',
    promotion_2: 'الإحالة 2: مكافأة رمز الإحالة',
    general_terms: 'الشروط والأحكام العامة',

    // sub-title
    eligibility: 'الأهلية',
    offer: 'العرض',
    conditions: 'الشروط',
    program_duration: 'مدة البرنامج',
    account_verification: 'التحقق من الحساب',
    limitations: 'القيود',
    modification_of_terms: 'تعديل الشروط',
    compliance: 'الامتثال',
    support: 'الدعم',

    error_messages: {
      referral_code_invalid:
        'يجب أن يتكون رمز الإحالة من 4 إلى 8 أحرف، ويمكن أن يحتوي فقط على أحرف أبجدية رقمية باستثناء "I" و "O"',
      referral_code_required: 'رمز الإحالة مطلوب',
    },

    // points
    eligibility_1: 'يجب على المستخدمين إيداع أكثر من 1 USDT في حسابهم على Win4Poker.',
    offer_1: 'سيحصل المستخدمون المؤهلون على هدية مجانية بقيمة 1 USDT تُودع مباشرة في حسابهم.',
    conditions_1: 'لا توجد قيود على هذا العرض.',
    conditions_2: 'يجب أن يتم الإيداع خلال فترة الإحالة المحددة من قبل Win4Poker.',
    conditions_3: 'يجب أن يمتلك المستخدمون حسابًا موثقًا لتأهيلهم لهذا العرض الإحالي.',

    eligibility_2: 'يجب على المستخدمين استخدام رمز إحالتهم الفريد للإحالة إلى الأصدقاء.',
    offer_2:
      'عندما يكمل الأصدقاء الذين تمت إحالتهم أول لعبة لهم، سيحصل الموصي على 3.5% من إجمالي مبلغ الجائزة كجائزة.',
    conditions_4:
      'يجب على الأصدقاء الذين تمت إحالتهم استخدام رمز الإحالة الخاص بالموصي عند التسجيل.',
    conditions_5: 'سيتم منح الجوائز في غضون ساعتين بعد أن يكمل الأصدقاء الذين تمت إحالتهم لعبتهم.',
    conditions_6: 'يمكن للمستخدمين تتبع إحالاتهم ومكافآتهم من خلال لوحة تحكم حساباتهم.',
    program_duration_1:
      'ستجري هذه العروض الترويجية خلال الفترات المحددة التي يتم الإعلان عنها على موقعنا وقنواتنا الرسمية.',
    account_verification_1: 'يجب أن يمتلك المشاركون حسابًا موثقًا بالكامل لتأهيلهم لأي مكافآت.',
    limitations_1:
      'قد يتم تعليق أو حظر حسابات المستخدمين الذين يتم اكتشاف أنهم يسيئون استخدام نظام الإحالة (مثل الإحالة الذاتية).',
    modification_of_terms_1:
      'تحتفظ Win4Poker بالحق في تعديل أو إنهاء هذه العروض الترويجية في أي وقت دون إشعار مسبق.',
    compliance_1:
      'يجب على المشاركين الامتثال لجميع القوانين واللوائح المعمول بها في نطاقهم القضائي فيما يتعلق بالألعاب عبر الإنترنت وبرامج الإحالة.',
    support_1:
      'لأي استفسارات أو مساعدة بخصوص برنامج الإحالة، يرجى الاتصال بفريق دعم العملاء لدينا.',

    // disclaimer
    disclaimer: 'إخلاء المسؤولية',
    disclaimer_1: 'جميع الجوائز تخضع للتوافر وقد تختلف بناءً على حالة الحساب والنشاط.',
    disclaimer_2:
      'Win4Poker لا تتحمل المسؤولية عن أي مشكلات تقنية قد تعيق تتبع الإحالات أو المكافآت بنجاح.',

    commission_calculation: {
      title: 'حساب العمولة',
      first_layer: 'المستوى الأول %',
      second_layer: 'المستوى الثاني %',
      third_layer: 'المستوى الثالث %',
      refers: 'يشير إلى',
      referrer: 'المحيل',
      content:
        'يتم خصم 5% من مبلغ الفوز كعمولة. يحصل البوابة على 30% <0>كحد أقصى</0> من العمولة. توزع البوابة 70% المتبقية من العمولة إلى المحيل الأعلى مستوى، الذي يمكنه تخصيص Z% من نسبة 70% من العمولة إلى المحيل في المستوى التالي. يمكن للمحيل في المستوى التالي أن يقرر تخصيص Y% من نسبة Z% من العمولة إلى المستوى الأدنى، وتستمر هذه العملية حتى تصل العمولة إلى المحيل الخاص بالفائز.',
      example: {
        title: 'مثال:',
        winner_wins: 'فوز الفائز: ${{value}}',
        total_commission: 'إجمالي العمولة: ${{value}}',
        gateway_total_commission_max: 'إجمالي عمولة البوابة (الحد الأقصى): ${{value}}',
        referral_total_commission_min: 'إجمالي عمولة الإحالة (الحد الأدنى): ${{value}}',

        referral_commissions: 'عمولات الإحالة (70 ≥ Z ≥ Y ≥ X ...):',
        referrer_1_commission: 'المحيل 1: ${{totalCommission}} × (Z% - Y%)',
        referrer_2_commission: 'المحيل 2: ${{totalCommission}} × (Y% - X%)',
        referrer_3_commission: 'المحيل 3: ${{totalCommission}} × X%',
      },
    },

    fixed_commission: 'عمولة ثابتة',
    custom_commission: 'عمولة عامة',
    invalid_commission_percentage: 'النسبة المئوية غير صالحة',
    commission_placeholder: 'أدخل النسبة المئوية',
    my_share: 'عمولتي',
  },
  ranking: {
    ranking: 'التصنيف',
    today: 'اليوم',
    this_week: 'هذا الأسبوع',
    this_month: 'هذا الشهر',
  },
  tournament: {
    you_have_won: 'لقد فزت',
    time_elapsed: 'الوقت المنقضي',
    prize_pool: 'مجموع الجوائز',
    entries: 'المشاركات',
    of: 'من',
    congratulations: 'تهانينا',
    thanks_for_your_joining: 'شكراً لمشاركتك',
    watch: 'مشاهدة',
    see_result: 'رؤية النتيجة',
    view_tournament: 'عرض البطولة',
    deregister: 'إلغاء التسجيل',
    start_in: 'تبدأ في <0>countdown</0>',
    full: 'ممتلئة',
    register_end_in: 'ينتهي التسجيل في <0>countdown</0>',
    my_ranking: 'ترتيبي',
    players: 'اللاعبون',
    register: 'تسجيل',
    pay_for_registration: 'دفع {{ticketFee}} للتسجيل',
    register_confirmation_message:
      'لتسجيل البطولة، سيتم فرض رسوم تذكرة قدرها {{ticketFee}}، هل تريد التسجيل في {{tournamentName}}؟',
    late_register: 'تسجيل متأخر',
    level: 'المستوى',
    blinds: 'الرهانات الإجبارية (SB/BB)',
    ante: 'الرهان المسبق',
    duration: 'المدة',
    game_rule: 'قاعدة اللعبة',
    game_mode: 'وضع اللعبة',
    speed: 'السرعة',
    general_information: 'معلومات عامة',
    ticket_fee: 'رسوم التذكرة',
    starting_stack: 'الرقائق الابتدائية',
    blinds_start: 'بداية الرهانات الإجبارية',
    ante_starts: 'بداية الرهان المسبق',
    raised_every: 'ترتفع كل',
    minutes: 'دقائق',
    prize: 'الجائزة',
    structure: 'الهيكل',
    gameModeTitle: {
      classic: 'كلاسيكي',
      turbo: 'توربو',
      hyper: 'هايبر',
    },
    gameModeDescription: {
      classic:
        'بطولة متعددة الطاولات كلاسيكية حيث يتنافس المشاركون للفوز بحصة من مجموع الجوائز الكلي.',
    },
    speedTitle: {
      regular: 'عادي',
      turbo: 'توربو',
      hyper: 'هايبر',
    },
    speedDescription: 'ترتفع الرهانات الإجبارية كل {{value}} دقائق',
    tournament: 'بطولة',
    today: 'اليوم',
    yesterday: 'الأمس',
    tomorrow: 'غداً',
    upcoming: 'القادمة',
    results: 'النتائج',
    on_going: 'جارية',
    title: 'تفاصيل البطولة',
    tables: 'الطاولات',
    minutes_short: 'د',
    current_blinds: 'الرهانات الإجبارية الحالية',
    next_blind_at: 'الرهان الإجباري التالي في',
    start_game_in: 'بدء اللعبة في',
    no_tournaments_available: 'لا توجد بطولات متاحة',
    you_have_not_participated_in_any_tournament_yet: 'لم تشارك في أي بطولة حتى الآن',
    tournament_started: 'بدأت البطولة',
    tournament_ended_msg: 'انتهت البطولة',
    tournament_canceled_msg: 'تم إلغاء البطولة',
    view_table: 'عرض الطاولة',
    view_player_table: 'عرض طاولة اللاعب',
    table_rebalancing: 'إعادة توزيع الطاولة',
    upcoming: 'قادمة',
    in_progress: 'جارية',
    finished: 'انتهت',
    waiting_enough_players_to_start: 'ينتظر إيداع اللاعبين لبدء البطولة',
    cancelled: 'تم إلغاء',
    table_rebalancing: 'إعادة توازن الطاولة',
    too_many_rooms_description:
      'ستبدأ {{tournamentName}} قريبًا، ولكنك وصلت إلى الحد الأقصى لعدد الطاولات، يرجى مغادرة واحدة على الأقل من الطاولات التالية للانضمام إلى {{tournamentName}}.',
    leave: 'مغادرة',
    sit_in: 'الجلوس في {{name}}',
    ignore: 'تجاهل',

    re_entry_modal: {
      title: 'هل ترغب في العودة إلى البطولة؟',
      description:
        'لا يزال {{tournamentName}} مفتوحًا للانضمام، هل ترغب في إنفاق ${{ticketFee}} رسوم تذكرة للانضمام مرة أخرى إلى البطولة؟',
      re_enter: 'العودة للمشاركة',
      view_tournament: 'عرض البطولة',
    },
    waiting_for_players: {
      title: 'انتظار اللاعبين',
      message: 'انتظار {{count}} لاعب آخر للانضمام',
      message_plural: 'انتظار {{count}} لاعبين آخرين للانضمام',
    },
    thanks_for_joining: {
      title: 'شكراً لانضمامك!',
      description: 'شكراً لانضمامك إلى {{tournamentName}}. البطولة لا تزال جارية، يمكنك رؤية نتيجتك لاحقاً.',
      view_results: 'عرض نتائج البطولة',
    },
    cancel: {
      title: 'تم إلغاء البطولة',
      description: 'تم إلغاء البطولة "{{tournamentName}}".',
      refund_message: 'سيتم استرداد رسوم الدخول البالغة ${{amount}}.',
      confirm: 'موافق',
    },
    waiting_timer: {
      title: 'في انتظار اللاعبين',
      cancel_in: 'الإلغاء في',
    },
    waiting_for_players_timer: 'بانتظار اللاعبين',
    cancel_in: 'إلغاء في',
  },
  errorCodes: {
    default: {
      title: 'خطأ في النظام',
      message: 'حدث خطأ ما، يرجى المحاولة مرة أخرى لاحقاً',
    },

    WS_0000: 'خطأ في النظام',
    WS_0001: 'لا يمكن الدخول إلى أكثر من 4 غرف',
    WS_0002: 'لا يمكن مغادرة اللعبة أثناء الرهان الأعلى',
    WS_0003: 'خطأ في التحقق، يرجى تحديث الصفحة والمحاولة مرة أخرى',
    WS_0004: 'تم اكتشاف وجود أشخاص قريبين في الغرفة، لذلك لا يمكن الدخول مؤقتًا',
    WS_0005: 'لا يمكنك الخروج كلاعب يملك أعلى رهان. يرجى رمي البطاقات أولاً',
    WS_0006: 'خطأ في الشراء',
    WS_0007: 'غرفة اللعب غير موجودة',

    HP_0001: 'لا يمكن الدخول إلى أكثر من 4 غرف',
    HP_0002: 'لا يمكن الاتصال بالخادم حاليًا، يرجى المحاولة لاحقًا.',
    HP_0003: 'مبلغ الشراء غير كافٍ',
    HP_0004: 'رمز التحقق غير صالح',
    INVALID_EMAIL_PASS_CODE: 'رمز التحقق غير صالح',
    INVALID_OTP: 'رمز التحقق غير صالح',
    INVALID_REFERRAL_CODE: 'رمز الإحالة غير صالح',
    REFERRAL_CODE_ALREADY_USED: 'تم استخدام رمز الإحالة بالفعل',
    INSUFFICIENT_COINS: 'رصيد المحفظة غير كافٍ',
    JOIN_TOURNAMENT_ERROR: 'خطأ في الانضمام إلى البطولة',
    TOURNAMENT_IS_FINISHED: 'انتهت البطولة',
    LOCATION_CHECKING_FAILED: {
      PERMISSION_DENIED: 'تم رفض الوصول إلى الموقع.',
      POSITION_UNAVAILABLE: 'معلومات الموقع غير متاحة. يرجى المحاولة مرة أخرى لاحقًا.',
      TIMEOUT: 'انتهت مهلة طلب الحصول على موقعك. يرجى المحاولة مرة أخرى.',
      UNKNOWN: 'حدث خطأ غير معروف أثناء طلب موقعك.',
    },
    GPS_RESTRICTION:
      'لا يمكن تحديد الموقع أو انضم لاعب قريب منك إلى نفس الغرفة، يرجى المحاولة مرة أخرى لاحقًا',
  },
};
